import styled from 'styled-components'

export const AlarmRiskBollNotification = styled.div<{ color: string }>`
    min-width: 14px;
    min-height: 14px;
    background: ${({ color }) => color};
    border-radius: 50%;
`

export const AlarmDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: ${({ theme }) => theme['gray-200']};
    position: relative;
    height: 100%;
    padding: 24px 0px 0px 24px;
    /* color: var(--gray-100); */
    /* max-height: 700px;
    overflow-y: scroll; */
    * {
        scrollbar-width: auto;
        scrollbar-color: ${({ theme }) => theme['gray-300']} ${({ theme }) => theme['gray-100']};
    }

    *::-webkit-scrollbar {
        width: 16px;
    }

    *::-webkit-scrollbar-track {
        background: ${({ theme }) => theme['gray-100']};
    }

    *::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme['gray-300']};
        border-radius: 10px;
        border: 3px solid ${({ theme }) => theme['gray-100']};
    }

    .no-alarm-selected {
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
    }

    .details-header {
        padding: 0px 24px 0px 0px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        .title-notification-email {
            display: flex;
            gap: 16px;
            flex-direction: column;
            flex: 7;
            justify-content: space-between;
            .ball-name-bundle {
                display: flex;
                gap: 8px;
                align-items: center;

                .label-title-email {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: normal;
                    color: ${({ theme }) => theme['gray-800']};
                }
            }
            .label-time-notification {
                display: flex;
                align-items: center;
                gap: 9px;
                font-size: 12px;
                font-weight: 600;
                color: ${({ theme }) => theme['gray-800']};
                gap: 6px;
            }
        }
    }

    .label-name-group {
        font-weight: 400;
        font-size: 14px;
    }

    .description-notification {
        display: flex;
        flex-direction: column;
        gap: 16px;

        div {
            label {
                color: ${({ theme }) => theme['gray-800']};
            }
        }
    }
    .list-bowties-context {
        list-style-type: disc;
        display: flex;
        flex-direction: column;

        li {
            margin-left: 18px;
        }
    }

    span {
        cursor: default;
    }

    .hours-triggered {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        flex: 3;
        gap: 16px;
        flex-direction: column;
        align-items: flex-end;

        .no-outline-button {
            display: flex;
            gap: 4px;
            border-radius: 32px;
            justify-content: center;
            align-items: center;
            width: 150px;
        }

        .save-acknowledge {
            color: var(--blue-500);
            cursor: pointer;
            display: flex;
            gap: 4px;
            align-items: center;
            width: 150px;
            font-size: 13px;
            justify-content: flex-end;

            i {
                font-size: 16px;
                font-weight: 600;
            }
        }
    }

    .title-information-tab {
        font-weight: 600;
        font-size: 16px;
        color: ${({ theme }) => theme['gray-800']};
    }

    .subtitle-information-tab {
        font-weight: 400;
        font-size: 10px;
        color: ${({ theme }) => theme['gray-800']};
    }

    .option-acknowledge-alarms {
        position: absolute;
        display: flex;
        flex-direction: column;
        background: ${({ theme }) => theme['gray-0']};
        cursor: pointer;
        padding: 10px 20px;
        gap: 6px;
        right: 40px;
        top: 60px;
        box-shadow: 0px 8px 16px rgba(131, 145, 163, 0.3);
        border-radius: 4px;
    }

    .ackowledge-alarms-item {
        cursor: pointer;
        color: ${({ theme }) => theme['gray-700']};
    }

    .type-alarm-ball {
        width: 10%;
        color: ${({ theme }) => theme['red-500']};
        border-radius: 50%;
    }

    .timeline-alerts {
        display: flex;
        flex-direction: column;
        gap: 15px;
        border-top: 1px solid ${({ theme }) => theme['gray-400']};
        padding-top: 28px;
    }

    .alerts-message {
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: calc(100% - 177px);
    }

    .mb-6 {
        overflow-y: scroll;
    }

    .trigger-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        height: 100%;
        overflow-y: auto;
        margin-right: 22px;
    }
`

export const RiskNameNotification = styled.div<{ color: string }>`
    display: flex;
    justify-content: center;
    font-size: 13.8px;
    font-weight: 600;
    color: ${({ color }) => color};
    border: 1.15px solid ${({ color }) => color};
    gap: 9.2px;
    width: 60px;
    height: 23.6px;
    padding: 2px 9px;
    border-radius: 3.45px;
`
